export default {
  lookups: state => state.lookups,
  groups: state => state.groups,
  timeZones: state => state.timeZones,
  countries: state => state.countries,
  stateProvinces: state => state.stateProvinces,
  languages: state => state.languages,
  calibrateReady: state => state.calibrateReady,
  calibratePreCheckList: state => state.calibratePreCheckList,
  calibrateService: state => state.calibrateService,
  calibrateActionType: state => state.calibrateActionType,
  calibrateVerify: state => state.calibrateVerify
}



// WEBPACK FOOTER //
// ./src/store/modules/lookups/getters.js